import React from "react";
import { useParams } from "react-router-dom";
import WeekLinksBar from "../nav/WeekLinksBar";
import NflGamesScoreboard from "./NflGamesScoreboard";

export default function NflHome() {
  const { league: leagueUrl, season } = useParams();

  return (
    <div>
      <div style={{ margin: "0 0.5rem 1rem" }}>
        <WeekLinksBar path={`/${leagueUrl}/${season}/:week/nfl`} />
      </div>
      <NflGamesScoreboard />
    </div>
  );
}
